<template>
 <v-bottom-navigation
      fixed
      class="d-lg-none"
      temporary="true"
      color="lighten-1"
      style="z-index:100"
    >
      <v-btn @click="toggleShowFilters()">
        <span>Toggle search filters</span>
        <v-icon>mdi-menu</v-icon>
      </v-btn>

  </v-bottom-navigation>

</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import {
  TOGGLE_SHOW_FILTERS
} from "@/store/actions.type";

export default {
  data: () => ({
  }),

  methods: {
    toggleShowFilters() {
      store.dispatch(TOGGLE_SHOW_FILTERS);
    }
  }
};
</script>

